export const time_ranges = {
  morning: {
    time_start: 6,
    time_end: 12,
    icon: 'sun',
    title: 'Mattina'
  },
  early_afternoon: {
    time_start: 12,
    time_end: 15,
    icon: 'sun-half',
    title: 'Primo pomeriggio'
  },
  late_afternoon: {
    time_start: 15,
    time_end: 18,
    icon: 'sun-half',
    title: 'Tardo pomeriggio'
  },
  evening: {
    time_start: 18,
    time_end: 6,
    icon: 'moon',
    title: 'Sera'
  }
};
